import ExportConfig from "../../../Components/AdminComponents/ExportConfigComponents/ExportConfig";

const ExportConfigPage = () => {
  return <ExportConfig />;
};

export default ExportConfigPage;
